import { DocumentNode, gql, WatchQueryFetchPolicy } from "@apollo/client";
import { CategoryChartGroupType } from "../processors";
import { baseCategoryChartTaxonomy, baseCategoryTaxonomy } from "./base";

// const CATEGORY_CHART_QUERY = `{
//     ... on TaxonomyTermCategoryChart {
//         ${baseCategoryChartTaxonomy}
//         category: fieldCategory {
//             entity {
//                 ... on TaxonomyTermCategory {
//                     ${baseCategoryTaxonomy}
//                 }
//             }
//         }
//     }
// }
// `;

// const GET_CATEGORY_CHART_BY_CATEGORY_ID = (
//     categoryTermIds: number[],
//     categoryChartVisGroupType?: CategoryChartGroupType,
//     offset: number = 0,
//     limit: number = INFINITE_NUMBER
// ) => {
//     return gql`
//         query CategoryChart {
//             query: taxonomyTermQuery(
//                 offset: ${offset}, limit: ${limit},
//               filter: ${categoryChartFilter(categoryTermIds, categoryChartVisGroupType)}
//             ) {
//                 entities ${CATEGORY_CHART_QUERY}
//             }
//         }
//     `;
// };

// export const GET_CATEGORY_CHART_BY_CATEGORY_ID_PARAMS = (
//     categoryTermIds?: number[],
//     categoryChartVisGroupType?: CategoryChartGroupType,
//     offset = 0,
//     limit = INFINITE_NUMBER
// ): {
//     query: DocumentNode;
//     options: {
//         skip: boolean;
//         fetchPolicy: WatchQueryFetchPolicy;
//     };
// } => {
//     const allow = categoryTermIds == null || !categoryTermIds.filter(d => d != null).length ? false : true;

//     return {
//         query: GET_CATEGORY_CHART_BY_CATEGORY_ID(categoryTermIds, categoryChartVisGroupType, offset, limit),
//         options: {
//             skip: !allow,
//             fetchPolicy: "cache-first"
//         }
//     };
// };

const CATEGORY_CHART_QUERY = `
    ${baseCategoryChartTaxonomy},
    category {
        ${baseCategoryTaxonomy}
    }
`;

const GET_CATEGORY_CHART_BY_CATEGORY_ID = () => {
    return gql`
        query CategoryCharts($categoryTermIds: [Int!], $chartGroupType: String) {
            result: getCategoryChartsForCategories(
                categoryTermIds: $categoryTermIds
                chartGroupType: $chartGroupType
            ) { 
              ${CATEGORY_CHART_QUERY}
            }
        }
    `;
};

export const GET_CATEGORY_CHART_BY_CATEGORY_ID_PARAMS = (
    categoryTermIds?: number[],
    categoryChartVisGroupType?: CategoryChartGroupType
): {
    query: DocumentNode;
    options: {
        skip: boolean;
        fetchPolicy: WatchQueryFetchPolicy;
        variables: {
            categoryTermIds: number[];
            chartGroupType?: string;
        };
    };
} => {
    const allow = categoryTermIds == null || !categoryTermIds.filter(d => d != null).length ? false : true;

    return {
        query: GET_CATEGORY_CHART_BY_CATEGORY_ID(),
        options: {
            skip: !allow,
            fetchPolicy: "cache-first",
            variables: {
                categoryTermIds: categoryTermIds?.filter(d => d != null) ?? [],
                chartGroupType: categoryChartVisGroupType
            }
        }
    };
};
